import {z as zod} from "zod";

export type RetailLocationsProductCatalogueWorkspaceCapabilityConfiguration = Record<string, never>;

export const retailLocationsProductCatalogueWorkspaceCapabilityConfigurationValidator: zod.ZodType<RetailLocationsProductCatalogueWorkspaceCapabilityConfiguration> = zod.strictObject({});
